<div class="dialog-body" *ngIf="!data.type && !data.yesOrNoPopup &&  !data.message">
    <div class="dialog-content dialog-whitspace">{{data}}</div>
    <div class="text-center">
        <button class="mx-1 dialogAction button" type="button" (click)="acceptMessage()">OK</button>
    </div>
</div>
<div class="dialog-body" *ngIf="data.type == 'alert'">
    <div class="dialog-content dialog-whitspace">{{data.data}}
    </div>
    <div class="text-center mt-1">
        <button class="mx-1 dialogAction Cancelbutton" type="button" (click)="close()">No</button>
        <button class="mx-1 dialogAction submitBtn" type="button" (click)="acceptMessage()">Yes</button>
    </div>
</div>
<div class="dialog-body" *ngIf="data.yesOrNoPopup && !data.type && !data.message">
    <div class="dialog-content dialog-whitspace" [innerHTML]="data.errorMessage">
    </div>
    <div class=" text-center mt-1">
        <button class="mx-1 dialogAction Cancelbutton" type="button" (click)="closeno()">No</button>
        <button class="mx-1 dialogAction submitBtn" type="button" (click)="yes()">Yes</button>
    </div>
</div>
<div class="dialog-body" *ngIf="!data.type && !data.yesOrNoPopup && data.message == 'SUCCESS'">
    <div class="dialog-content dialog-whitspace" [innerHTML]="data.errorMessage"></div>
    <div class="text-center">
        <button class="mx-1 dialogAction button" type="button" (click)="agree()">OK</button>
    </div>
</div>
